import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { UserManagementComponent } from "./user-management/user-management.component";
import { ViewUserComponent } from "./view-user/view-user.component";
import { AddUserComponent } from "./add-user/add-user.component";
import { PermissionGuard } from "../../guards/permisson.guard";
import { UserDashboardComponent } from "./user-dashboard/user-dashboard.component";
import { UserlistComponent } from "./userlist/userlist.component";
import { ViewUserPickDropOrder } from "./view-user-pickdrop-order/view-user-pickdrop-order.component";
import { CouponlistComponent } from "./couponlist/couponlist.component";
import { UserDetailComponent } from "./user-detail/user-detail.component";
import { UserRecentBookingsComponent } from "./user-recent-bookings/user-recent-bookings.component";
import { UserAnalyticsComponent } from "./user-analytics/user-analytics.component";
import { UserAnalyticsDetailComponent } from "./user-analytics-detail/user-analytics-detail.component";
import { UserSourceComponent } from "./user-source/user-source.component";

const routes: Routes = [
  {
    path: "",
    component: UserManagementComponent,
    children: [
      { path: "", redirectTo: "/main/user-management/list", pathMatch: "full" },
      { path: "view-user", component: ViewUserComponent },
      { path: "list", component: UserlistComponent },
      { path: "recent-bookings", component: UserRecentBookingsComponent },
      { path: "user-detail/:id", component: UserDetailComponent },

      { path: "coupon", component: CouponlistComponent },
      { path: "view-user-pick-and-drop-order", component: ViewUserPickDropOrder },
      {
        path: "add-user",
        canActivate: [PermissionGuard],
        data: { access: "users", level: "W" },
        component: AddUserComponent,
      },
      { path: "user-analytics", component: UserAnalyticsComponent },
      {
        path: "user-analytics-detail/:id",
        component: UserAnalyticsDetailComponent,
      },
      { path: "user-source", component: UserSourceComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserManagementRoutingModule {}
